import React from "react";
import { useLocation } from "react-router-dom";
import { navItems } from "../Sidebar/navConfig"; // <-- IMPORT the same config file

const WelcomeSection = () => {
  const location = useLocation();

  // Find the current navigation item based on the URL path
  const currentNavItem =
    navItems.find((item) => location.pathname.startsWith(item.path)) || null;

  // Determine the title and subtitle to display
  const pageTitle = currentNavItem ? currentNavItem.label : "Dashboard";
  const pageSubtitle = currentNavItem
    ? currentNavItem.subtitle
    : "Welcome to your dashboard.";

  return (
    <div className="smai-welcome-section">
      <h1 className="smai-welcome-title">{pageTitle}</h1>
      <p className="smai-welcome-subtitle">{pageSubtitle}</p>
    </div>
  );
};

export default WelcomeSection;
